/**************************************************
 * Nombre:       Home_Salon
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import foto from "../../../Recursos/tmp_habitacion.png";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Salon = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 40 : 48,
                                            fontWeight: 600,
                                            color: theme.palette.primary.main
                                        }}>Salón de eventos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{fontSize: 18, fontWeight: 400}}>
                                        Nuestro salón de eventos, con años de experiencia, está disponible para ofrecer
                                        un
                                        espacio privado y cómodo, ideal para reuniones y celebraciones, con el servicio
                                        personalizado que nuestros huéspedes merecen.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                            <Splide
                                //ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: true,
                                    perMove: 1,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'free',
                                    snap: true,
                                    interval: 5000,
                                    noDrag: true,
                                    focus: 'center',
                                    type: 'loop',
                                    padding: '0rem',
                                    gap: 20,

                                }}
                            >

                                {imagenes.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qer${index}`}>
                                            <img src={item} width={'100%'} height={'auto'}
                                                 style={{borderRadius: 8, border: 0, borderColor: '#000'}}/>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Salon

const imagenes = [foto, foto, foto, foto]